import { SocialPlatform, type AppConfig } from "@iyk/vf-app-config"
import { Duration } from "effect"

export const appConfig: AppConfig<"mystery-skulls"> = {
  appId: "mystery-skulls",
  cookiePrefix: "ms",
  lang: "EN",
  artist: {
    name: "Mystery Skulls"
  },
  meta: {
    description: "Mystery Skulls"
  },
  emailSender: {
    name: "Mystery Skulls",
    email: "mysteryskulls@iyk.app"
  },
  s3: {
    get assets() {
      const baseUrl = "https://assets.iyk.app"
      return {
        baseUrl,
        vfUrl: `${baseUrl}/vf`,
        appUrl: `${baseUrl}/${appConfig.appId}`
      }
    },
    get files() {
      return {
        exclusives: `${appConfig.appId}/exclusives`,
        fanClips: `${appConfig.appId}/fan-clips`,
        merchSkus: `${appConfig.appId}/merch-skus`,
        playlistCoverImages: `${appConfig.appId}/playlist-cover-images`,
        showImages: `${appConfig.appId}/show-images`,
        showCheckInRequestImages: `${appConfig.appId}/check-in-request-images`
      }
    },
    get music() {
      return {
        trackAudios: `${appConfig.appId}/track-audios`,
        playlistDownloadFiles: `${appConfig.appId}/playlist-download-files`
      }
    }
  },
  merch: {
    initialOwnerId: "f4513e00-bb5f-4623-ac4b-9c5e06c45bf5",
    initialOwnerAddress: "0xbe18b7859264a45be374970326e237a93b0aa230"
  },
  tasks: {
    exclusiveLinkDelay: Duration.hours(1)
  },
  checkIn: {
    hidePrompt: false
  },
  shopUrl: "https://mysteryskullshq.com/collections/all",
  socialLinks: [
    {
      platform: SocialPlatform.Website,
      label: "Website",
      href: "https://mysteryskullshq.com"
    },
    {
      platform: SocialPlatform.Instagram,
      label: "Instagram",
      href: "https://www.instagram.com/mysteryskulls"
    },
    {
      platform: SocialPlatform.Twitter,
      label: "Twitter",
      href: "https://x.com/MysterySkulls"
    },
    {
      platform: SocialPlatform.Facebook,
      label: "Facebook",
      href: "https://www.facebook.com/mysteryskulls"
    },
    {
      platform: SocialPlatform.Youtube,
      label: "YouTube",
      href: "https://www.youtube.com/channel/UC0jd1RjiMOAbs4CikoADJGA"
    }
  ],
  joinProof: null,
  get assets() {
    return {
      images: {
        avatar: `${appConfig.s3.assets.appUrl}/avatar.webp`,
        og: `${appConfig.s3.assets.appUrl}/og.png`,
        logo: {
          url: `${appConfig.s3.assets.appUrl}/logo.png`,
          width: 115
        },
        background: `${appConfig.s3.assets.appUrl}/background.webp`,
        howToTap: null,
        email: {
          logo: {
            url: `${appConfig.s3.assets.appUrl}/email-logo.png`,
            width: 115
          }
        },
        roulette: {
          images: Array.from({ length: 6 }, (_, i) => `${appConfig.s3.assets.vfUrl}/roulette/${i + 1}.webp`)
        },
        enableLocation: {
          ios: {
            step1: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_ios_1.png`,
            step2: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_ios_2.png`
          },
          android: {
            step1: `${appConfig.s3.assets.vfUrl}/check-in/enable_location_android.png`
          }
        }
      },
      videos: {
        marquee: null,
        howToTap: null
      },
      documents: {
        privacyPolicy: `${appConfig.s3.assets.baseUrl}/iyk-privacy-policy.pdf`,
        termsOfService: `${appConfig.s3.assets.baseUrl}/iyk-terms-of-service.pdf`,
        artistPrivacyPolicy: null,
        artistTermsOfService: null,
        sweepstakeRules: null
      }
    }
  }
}
